import Link from 'next/link';
import { Flame } from 'lucide-react';
import { SocialShareButtons } from './SocialShareButtons';

interface FooterProps {
    theme?: 'light' | 'dark';
}

export function Footer({ theme = 'light' }: FooterProps) {
    const isDark = theme === 'dark';

    // Colors based on theme
    const bgClass = isDark ? 'border-white/5' : 'bg-white border-slate-100';
    const borderClass = isDark ? 'border-t border-white/5' : 'border-t border-slate-100';
    const textBrand = isDark ? 'text-white' : 'text-slate-900';
    const textPrimary = isDark ? 'text-slate-400' : 'text-slate-500';
    const textSecondary = isDark ? 'text-slate-600' : 'text-slate-400';
    const iconBg = isDark ? 'bg-slate-800' : 'bg-slate-900';

    return (
        <footer className={`py-12 px-6 ${isDark ? '' : 'bg-white'} ${borderClass}`}>
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-10 text-center md:text-left">

                {/* Left: Brand & Dev */}
                <div className="flex flex-col items-center md:items-start gap-4 md:flex-1">
                    <div className="flex items-center gap-2">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${iconBg}`}>
                            <Flame size={16} className="text-white" />
                        </div>
                        <span className={`font-black tracking-tight ${textBrand}`}>SMOKEFREE.PRO</span>
                    </div>
                    <p className={`text-xs font-bold tracking-wider ${textSecondary}`}>
                        Developed by <a href="https://aeaeng.com/" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-400 transition-colors">Tanagrid Udomphol</a>
                    </p>
                </div>

                {/* Center: Contact Details */}
                <div className="flex flex-col items-center gap-2 md:flex-1">
                    <p className={`text-xs font-bold uppercase tracking-widest mb-1 ${isDark ? 'text-slate-300' : 'text-slate-900'}`}>Contact Details</p>
                    <div className={`text-[10px] font-medium space-y-1.5 flex flex-col items-center ${textPrimary}`}>
                        <a href="mailto:u.tanagrid@gmail.com" className="hover:text-blue-500 transition-colors flex items-center gap-2">
                            <span className={isDark ? 'text-slate-500' : 'text-slate-400'}>Email:</span> u.tanagrid@gmail.com
                        </a>
                        <a href="https://line.me/ti/p/h9U36ILleY" target="_blank" rel="noopener noreferrer" className="hover:text-green-500 transition-colors flex items-center gap-2">
                            <span className={isDark ? 'text-slate-500' : 'text-slate-400'}>Line ID:</span> u.tanagrid
                        </a>
                        <a href="tel:0887883198" className="hover:text-blue-500 transition-colors flex items-center gap-2">
                            <span className={isDark ? 'text-slate-500' : 'text-slate-400'}>Tel:</span> 088-7883198
                        </a>
                    </div>

                    <SocialShareButtons theme={theme} />
                </div>

                {/* Right: Copyright */}
                <div className={`text-xs font-bold uppercase tracking-widest md:text-right md:flex-1 pt-2 ${textSecondary}`}>
                    © {new Date().getFullYear()} SmokeFree Pro. <br /> Application for Health.
                </div>
            </div>
        </footer>
    );
}
